import "./App.css";
import { useEffect, useState } from "react";
import Loading from "./shared/loading";
import RoutesApp from "./routes";

function isTokenValid(token) {
  try {
    if (!token) return false;

    const payloadBase64 = token.split(".")[1];
    const payloadJson = atob(payloadBase64);
    const payload = JSON.parse(payloadJson);

    if (!payload.exp) return false;

    const now = Math.floor(Date.now() / 1000);
    return payload.exp > now;
  } catch (error) {
    return false;
  }
}

function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [isAuth, setIsAuth] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (token && isTokenValid(token)) {
      setIsAuth(true);
    } else {
      localStorage.removeItem("token");
      setToken(null);
      setIsAuth(false);
    }

    setIsLoading(false);
  }, [token]);

  if (isLoading) {
    return <Loading />;
  }

  return <RoutesApp isAuth={isAuth} setIsAuth={setIsAuth} token={token} />;
}

export default App;
